import { Link } from "react-router-dom";
import { categoryList } from "@/utils/movies";

export default function CategoryQuickEntry() {
  return (
    <section className="w-full max-w-[1400px] mx-auto px-4 md:px-6 pt-8 md:pt-12">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950">
            分类快捷入口
          </h2>
          <p className="mt-1 text-sm text-foreground-500">三大频道，快速直达你想看的内容</p>
        </div>
      </div>

      <div className="flex md:grid md:grid-cols-3 gap-4 overflow-x-auto no-scrollbar pb-1">
        {categoryList.map((category) => (
          <Link
            key={category.key}
            to={`/category/${category.slug}`}
            className="group relative min-w-[260px] md:min-w-0 h-40 rounded-lg overflow-hidden cursor-pointer animate-scale-in"
          >
            <img
              src={category.image}
              alt={`${category.name}频道`}
              title={`爱看视频${category.name}频道`}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/35 to-black/10" />
            <div className="absolute inset-0 p-5 flex flex-col justify-end">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 mb-3">
                <i className={`${category.icon} text-xl`}></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-background-50">
                {category.name}
              </h3>
              <p className="text-xs text-background-100/85 mt-0.5">{category.short}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}